import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useState } from 'react';
import { FormLabelProps, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { Placement } from 'react-bootstrap/esm/types';
import useMobile from '../../hooks/useMobileHook';

export type StatusDotVariant = 'orange';
export type IconVariant = 'default' | 'danger';

export type customLabelProps = FormLabelProps &
  React.PropsWithChildren<{
    leftIcon?: IconProp;
    rightIcon?: IconProp;
    statusDot?: StatusDotVariant;
    iconVariant?: IconVariant;
    tooltip?: React.ReactElement;
    tooltipPos?: Placement;
  }>;

const Label = ({
  leftIcon,
  rightIcon,
  statusDot,
  children,
  iconVariant = 'default',
  tooltip,
  tooltipPos = 'top',
  ...props
}: customLabelProps) => {
  const [show, setShow] = useState(false);
  const isMobile = useMobile();

  const handleOnToggle = () => {
    setShow(!show);
  };

  return (
    <div
      {...props}
      className={`${props.className} custom-label ${
        iconVariant === 'danger' ? 'danger' : ''
      }`}
    >
      {leftIcon && tooltip ? (
        <span className="icon-left">
          <OverlayTrigger
            placement={tooltipPos}
            overlay={<Tooltip id={`tooltip-${tooltipPos}`}>{tooltip}</Tooltip>}
            show={show}
            trigger={isMobile ? 'click' : undefined}
            rootClose
            onToggle={
              tooltip ? (isMobile ? handleOnToggle : undefined) : undefined
            }
          >
            <span>
              <FontAwesomeIcon icon={leftIcon as IconProp} />
            </span>
          </OverlayTrigger>
        </span>
      ) : leftIcon ? (
        <span className="icon-left">
          <FontAwesomeIcon icon={leftIcon} />
        </span>
      ) : null}
      {statusDot && (
        <span className={'icon-left status-dot ' + statusDot}></span>
      )}
      <span className="d-flex align-items-center">{children}</span>

      {rightIcon && tooltip ? (
        <span className="icon-right">
          <OverlayTrigger
            placement={tooltipPos}
            overlay={<Tooltip id={`tooltip-${tooltipPos}`}>{tooltip}</Tooltip>}
            show={isMobile ? show : undefined}
            trigger={isMobile ? 'click' : undefined}
            rootClose
            onToggle={tooltip ? handleOnToggle : undefined}
          >
            <span>
              <FontAwesomeIcon icon={rightIcon as IconProp} />
            </span>
          </OverlayTrigger>
        </span>
      ) : rightIcon ? (
        <span className="icon-right">
          <FontAwesomeIcon icon={rightIcon} />
        </span>
      ) : null}
    </div>
  );
};

export default Label;
